// https://www.geradorcnpj.com/javascript-validar-cnpj.htm
export const validarCnpj = cnpj => {
  if (!cnpj) {
    return false
  }

  const normalizedCnpj = cnpj.replace(/[^\d]+/g, '')
  if (normalizedCnpj === '' || normalizedCnpj.length !== 14) {
    return false
  }

  // Valida DVs
  let tamanho = normalizedCnpj.length - 2
  let numeros = normalizedCnpj.substring(0, tamanho)
  const digitos = normalizedCnpj.substring(tamanho)
  let soma = 0
  let pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado !== parseInt(digitos.charAt(0), 10)) {
    return false
  }

  tamanho += 1
  numeros = normalizedCnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) {
      pos = 9
    }
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  return resultado === parseInt(digitos.charAt(1), 10)
}
